import React, { Component } from 'react';
import Modal from '../Modal';
import YoutubeVideoEmbed from '../YoutubeVideoEmbed';
import './StoryVideo.scss';

class StoryVideo extends Component {

  render () {
    const { 
      onClose, videoId , csfModal
    } = this.props;

    const baseClassName = 'pb-story-video';

    return (
      <Modal  parentClassName={ csfModal ? `${baseClassName}__modal-wrapper` : null } onClose={onClose} noContentPadding noDimensionRestrictionsWithMaxWidth noContentScroll>
      <YoutubeVideoEmbed videoId={videoId} allowFullScreen/>
    </Modal>
    );
  }
};

export default StoryVideo;



// WEBPACK FOOTER //
// ./src/components/Book/StoryVideo.jsx